module.exports = __webpack_public_path__ + "img/bg_poster2.b6633e2c.png";